import { VisitorQueryContext } from '@fingerprintjs/fingerprintjs-pro-react';

export const adaptVisitorData = (
  visitorData: VisitorQueryContext<any>,
): { visitorId: string; data: string } => {
  if (!visitorData.data) {
    throw new Error('Visitor data is not available');
  }

  return {
    visitorId: visitorData.data.visitorId,
    data: JSON.stringify(visitorData),
  };
};
